import LogoImage from "./LogoImage";

const Logo: React.FCC<{ href?: string; className?: string }> = ({
  href,
  className = "h-5 w-fit",
}) => {
  return <LogoImage className={className} />;
};

export default Logo;
